var ShowErrorWay = {
    SHOW_ALL: 1,
    SHOW_FIRST: 2
}

export { ShowErrorWay };